/** @format */

// has raw color #rawcolor (comment to help find the comp in the near future for further updates)

import PropTypes from 'prop-types';
import {useState} from 'react';
import classNames from 'classnames';
import {IconButton} from '@sttark/design-system';

export function Banner({children, onClose, className}) {
    const [closed, setClosed] = useState(false);
    const handleClose = () => {
        onClose?.();
        setClosed(true);
    };

    if (closed) return null;

    const bannerClass = classNames(
        'content-box d-flex p-2 bg-accent-primary text-center',
        className
    );

    return (
        <div className={bannerClass}>
            <div className="flex-grow-1 my-1">{children}</div>
            <div className="flex-shrink-0">
                <IconButton
                    secondary
                    className="color-content-lightest"
                    icon="CloseSmall"
                    color="#FFFFFF"
                    onClick={handleClose}
                />
            </div>
        </div>
    );
}

Banner.propTypes = {
    children: PropTypes.node.isRequired,
    onClose: PropTypes.func
};
